export default __webpack_public_path__ + "static/media/trophy-large.e28dad9d.svg";